import { Component } from '@angular/core';

@Component({
  selector: 'app-flat-layout',
  templateUrl: './flat-layout.component.html',
})
export class FlatLayoutComponent {}
